// removed by extract-text-webpack-plugin
module.exports = {"ordersWrap":"qempo_PurchasesPasts_ordersWrap-2MPXqwc","mobileOptions":"qempo_PurchasesPasts_mobileOptions-3XzFWca","sortOptions":"qempo_PurchasesPasts_sortOptions-2tfRZrQ","down":"qempo_PurchasesPasts_down-17F2b8m","up":"qempo_PurchasesPasts_up-2pLR8nT"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/components/PurchasesPasts/PurchasesPasts.scss
// module id = 1805
// module chunks = 0